import React, { useState } from 'react';
import KPISet from '../components/KPISet';
import Flow from './Flow';
import List from './List';
import { Tabs, Tab, TabPanel, TabList } from '@mui/joy';
import { Box } from '@mui/joy';
import JSONPretty from 'react-json-pretty';
import { useDrawer } from 'src/mtska-frontend-app-component';

const dataProviderName = 'partnershipDeals/deal';

const Default = () => {
    const [tabValue, setTabValue] = useState(0);
    const defaultFilters = { items: [] };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} />
        <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} sx={{background:'transparent'}}>
            <TabList>
                <Tab>List</Tab>
                <Tab>Flow</Tab>
            </TabList>
            <TabPanel value={0} sx={{padding:'10px 0'}}>
                <List filters={defaultFilters} />
            </TabPanel>
            <TabPanel value={1} sx={{padding:'10px 0'}}>
                <Flow filters={defaultFilters} />
            </TabPanel>
        </Tabs>
    </>

}

export default Default;


